import React, { useContext, useEffect, useState } from "react";
import { apiPut, apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import { isEmpty } from "lodash";
import useToastContext from "hooks/useToastContext";
import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../utils/helpers";
import { NavLink } from "react-router-dom";
import AuthContext from "context/AuthContext";
import dayjs from "dayjs";
import Pagination from "pages/Pagination";
import ReportReplyModal from "./reportReplyModal";
import { FaReply } from "react-icons/fa";
import DesView from "./descriptionViewModal";

const ReportedContent = ({
  users
}) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const { logoutUser, user } = useContext(AuthContext);
  const [description, setDescription] = useState('')
  const [viewDesShowModal, setViewDesShowModal] = useState(false)
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10,
  });
  const [reports, setAllReports] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [item, setItem] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [showModal, setShowModal] = useState(false)
  const [filterData, setFilterData] = useState({
    status: "",
    searchKey: "",
    startDate: "",
    endDate: "",
    isReset: false,
    isFilter: false,
  });
  const [sort, setSort] = useState({
    sort_key: "createdAt",
    sort_type: "desc",
  });
  const manager =
    user?.permission?.find((e) => e.manager === "customers") ?? {};

  function Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  const handlePageClick = (event) => {
    const newPage = event.selected + 1;
    setPage(newPage);
  };

  const toggleModal = (item) => {
    setShowModal(!showModal)
    setItem(item ?? {})
  }

  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status:
          item?.changeStatus === "deactivated" ? "deactivated" : "noAction",
      };
      const path = `${apiPath.reportChangeStatus}/${item?._id}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        allReports();
      }
      // }
    } catch (error) {
      console.log("error in get all reports list==>>>>", error.message);
    }
  };

  const allReports = async (data) => {
    try {
      const { status, startDate, endDate, searchKey, isFilter } = filterData;
      if (
        (data?.deletePage && !(users?.length > 1)) ||
        (isFilter && status && data?.statusChange && !(users?.length > 1))
      ) {
        if (!(users?.length > 1)) {
          setPage(page - 1);
          setIsDelete(true);
          setPaginationObj({ ...paginationObj, page: page - 1 });
        }
      } else {
        setIsDelete(false);
      }
      const payload = {
        page,
        pageSize,
        status,
        start_date: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
        end_date: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
        keyword: searchKey.trim(),
        sort_key: sort.sort_key,
        sort_type: sort.sort_type,
      };

      const path = apiPath.reportContentList;
      const result = await apiGet(path, payload);
      if (result?.status === 200) {
        const response = result?.data?.results;
        const resultStatus = result?.data?.success;
        setAllReports(response?.docs);
        setPaginationObj({
          ...paginationObj,
          page: resultStatus ? response.page : null,
          pageCount: resultStatus ? response.totalPages : null,
          perPageItem: resultStatus ? response?.docs.length : null,
          totalItems: resultStatus ? response.totalDocs : null,
        });
      }
    } catch (error) {
      console.log("error ", error);
      setPaginationObj({});
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };

  const handleSearchKey = (e) => {
    setFilterData({ ...filterData, searchKey: e.target.value, isFilter: true });
    setPage(1);
  };

  const handleReset = () => {
    setFilterData({
      status: "",
      searchKey: "",
      startDate: "",
      endDate: "",
      isReset: true,
      isFilter: false,
    });
    setPage(1);
    setIsDelete(true);
  };
  const statusPage = (e) => {
    setFilterData({ ...filterData, status: e.target.value, isFilter: true });
    setPage(1);
    setIsDelete(true);
  };

  const handleDescriptionView = (item) => {
    setDescription(item)
    setViewDesShowModal(true)
  }

  useEffect(() => {
    allReports();
  }, [page, filterData, sort]);

  return (
    <div className="p-3">
      <div className="grid py-3">
        <div className="flex flex-wrap  items-center">
          <div className="flex items-center lg:pt-0 pt-3 flex-wrap justify-center">
            <div className="flex items-center md:justify-end">
              <label
                htmlFor="default-search"
                className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
              >
                {t("O_SEARCH")}
              </label>
              <div className="flex">
                <div className="relative ">
                  <div className="absolute inset-y-0 right-0 flex items-center pl-3 mr-3 pointer-events-none">
                    {!filterData?.searchKey && (
                      <svg
                        aria-hidden="true"
                        className="w-4 h-4 text-[#A5A5A5] dark:text-gray-40"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    )}
                  </div>
                  <input
                    type="search"
                    id="default-search"
                    className="block w-full p-2 outline-none text-sm text-gray-900 2xl:min-w-[250px] xl:min-w-[300px] rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder={t("O_SEARCH_BY_NAME")}
                    value={filterData?.searchKey}
                    title=""
                    required
                    onChange={(e) => handleSearchKey(e)}
                  />
                </div>
              </div>
            </div>
            <div className="flex items-center ml-3">
              <select
                id="countries"
                type=" password"
                name="floating_password"
                className="block p-2 w-full text-sm text-[#A5A5A5] bg-transparent border-2 rounded-lg border-[#DFDFDF]  dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0  peer"
                placeholder=" "
                value={filterData?.status}
                onChange={(e) => statusPage(e)}
              >
                <option defaultValue value="">
                  {t("O_ALL")}
                </option>
                <option value="pending">{t("O_PENDING")}</option>
                <option value="deactivated">{t("O_DE_ACTIVE")}</option>
                <option value="noAction">{t("NO_ACTION")}</option>
              </select>
            </div>
            <button
              type="button"
              onClick={handleReset}
              className="bg-LightBlue text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2"
            >
              {t("O_RESET")}
            </button>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-2">
                #
              </th>
              <th
                scope='col'
                className='py-3 px-2 cursor-pointer'
                onClick={() => {
                  if (sort.sort_key === 'userUniqueId' && sort.sort_type === 'asc') {
                    setSort({
                      sort_key: 'userUniqueId',
                      sort_type: 'desc'
                    })
                  } else {
                    setSort({
                      sort_key: 'userUniqueId',
                      sort_type: 'asc'
                    })
                  }
                }}
              >
                <div className='flex justify-left'>
                  <span>{t('O_USER_ID')}</span>
                  <span>
                    {sort.sort_key === 'userUniqueId' && sort.sort_type === 'asc' && (
                      <BsArrowUpShort className='w-4 h-4' />
                    )}
                    {sort.sort_key === 'userUniqueId' && sort.sort_type === 'desc' && (
                      <BsArrowUpShort className='w-4 h-4 rotate-180' />
                    )}
                  </span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sort_key === "fullName" &&
                    sort.sort_type === "asc"
                  ) {
                    setSort({
                      sort_key: "fullName",
                      sort_type: "desc",
                    });
                  } else {
                    setSort({
                      sort_key: "fullName",
                      sort_type: "asc",
                    });
                  }
                }}
              >
                <div className="flex ">
                  <span>{t("O_USER_NAME")} </span>
                  <span>
                    {sort.sort_key === "fullName" &&
                      sort.sort_type === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sort_key === "fullName" &&
                      sort.sort_type === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-2 text-right">
                <div className="text-right">
                  <span>{t("O_MOBILE")}</span>
                </div>
              </th>
              <th scope="col" className="py-3 px-2 text-left">
                <div className="text-left">
                  <span>{t("O_REPORTED_CONTENT")}</span>
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-2 cursor-pointer"
                onClick={() => {
                  if (
                    sort.sort_key === "createdAt" &&
                    sort.sort_type === "asc"
                  ) {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "desc",
                    });
                  } else {
                    setSort({
                      sort_key: "createdAt",
                      sort_type: "asc",
                    });
                  }
                }}
              >
                <div className="flex justify-end">
                  <span>{t("O_REPORT_DATE_TIME")}</span>
                  <span>
                    {sort.sort_key === "createdAt" &&
                      sort.sort_type === "asc" && (
                        <BsArrowUpShort className="w-4 h-4" />
                      )}
                    {sort.sort_key === "createdAt" &&
                      sort.sort_type === "desc" && (
                        <BsArrowUpShort className="w-4 h-4 rotate-180" />
                      )}
                  </span>
                </div>
              </th>
              <th scope="col" className="py-3 px-2 text-left">
                {t("O_STATUS")}
              </th>
              <th scope="col" className="py-3 px-2 text-left">
                {t("O_IS_REPLIED")}
              </th>
              <th scope="col" className="py-3 px-2 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {reports &&
              reports?.map((item, i) => (
                <tr
                  key={i}
                  className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                >
                  <th
                    scope="row"
                    className="py-2 px-2 border-r font-medium text-gray-900  dark:text-white"
                  >
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r text-right'>
                    {item?.userDetails?.userUniqueId}
                  </td>
                  <td className="py-2 px-2 border-r">
                    { Capitalize(item?.userDetails?.fullName) }
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {item?.userDetails?.mobile}
                  </td>
                  <td className="py-2 px-2 border-r text-left">
                    {(item?.comment).slice(0,50)}{item?.comment?.length > 50 && <span className='text-black cursor-pointer' onClick={()=> handleDescriptionView(item?.comment)}> {t('O_READ_MORE')}</span>}
                  </td>
                  <td className="py-2 px-2 border-r text-right">
                    {helper.dateFormat(item?.createdAt)}
                  </td>
                  <td className="py-2 px-2 border-r text-left">
                    {
                      item?.status === "deactivated"
                      ? t("O_DE_ACTIVE")
                      : item?.status === "noAction"
                      ? t("NO_ACTION")
                      : t("O_PENDING")
                    }
                  </td>
                  <td className="py-2 px-2 border-r text-left">
                    {item?.isReplied
                      ? 'Yes'
                      : "No"}
                  </td>
                  <td className="py-2 px-2 border-l">
                    <div className="">
                      <ul className="flex justify-center">
                        <>
                          <li className="px-2 py-2 hover:bg-white hover:text-LightBlue">
                            <NavLink
                            title={t('O_VIEW_USER')}
                            to='/help-and-support/report-content'
                            state={{ item }}
                            >
                              {" "}
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </NavLink>
                          </li>
                          {item?.status === "pending" && (
                            <>
                              <li
                                className="px-2 py-2 hover:bg-white hover:text-LightBlue text-blue-500 cursor-pointer"
                                onClick={() =>
                                  helper.alertFunction(
                                    `${t('ARE_YOU_SURE_TO_CHANGE_STATUS_DEACTIVE')}`,
                                    { ...item, changeStatus: "deactivated" },
                                    handelStatusChange
                                  )
                                }
                              >
                                {t("O_DE_ACTIVE")}
                              </li>
                              <li
                                className="px-2 py-2 hover:bg-white hover:text-LightBlue text-blue-500 cursor-pointer"
                                onClick={() =>
                                  helper.alertFunction(
                                    `${t('ARE_YOU_SURE_TO_CHANGE_STATUS_NO_ACTION')}`,
                                    { ...item, changeStatus: "noAction" },
                                    handelStatusChange
                                  )
                                }
                              >
                                {t("NO_ACTION")}
                              </li>
                            </>
                          )}
                          {(manager?.add ||
                          user?.role==='admin') && !item?.isReplied && (
                            <li
                              onClick={() => toggleModal(item)}
                              className='px-2 py-2 hover:bg-white hover:text-LightBlue'
                            >
                              <span
                                title={t('O_REPLY')}
                                className='hover:text-blue-700 transition duration-150 ease-in-out'
                                data-bs-toggle='tooltip'
                              >
                                <FaReply className='cursor-pointer w-5 h-5 text-slate-600' />
                              </span>
                            </li>
                          )}
                        </>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(reports) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-2 px-2 border-r" colSpan={8}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
        {paginationObj?.totalItems ? (
          <Pagination
            handlePageClick={handlePageClick}
            options={paginationObj}
            isDelete={isDelete}
            page={page}
          />
        ) : null}
      </div>
      <>
      {showModal && <ReportReplyModal show={showModal} onHide={toggleModal} allReports={allReports} editData={item}  setPage={setPage}/>}
      {viewDesShowModal ? (
        <DesView
          setViewDesShowModal={setViewDesShowModal}
          description={description}
        />
      ) : null}
      </>
    </div>
  );
};

export default ReportedContent;
